/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useContext, useCallback, useEffect, useMemo
} from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, useCheckSubmissionVMDirty } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import messages from './MobileHomesComponent.messages.js'
import metadata from './MobileHomesComponent.metadata.json5';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import PropertyDetailsComponent from '../PropertyDetails/PropertyDetailsComponent';
import UtilitiesComponent from '../Utilities/UtilitiesComponent.jsx';
import OilTankComponent from '../OilTank/OilTankComponent.jsx';
import AdditionalInformationComponent from '../AdditionalInformation/AdditionalInformationComponent.jsx';
import HobbyFarmApplicationComponent from '../HobbyFarmApplication/HobbyFarmApplicationComponent.jsx';
import SolidFuelHeatingComponent from '../SolidFuelHeating/SolidFuelHeatingComponent.jsx';
import IncidentalOfficeComponent from '../IncidentalOffice/IncidentalOfficeComponent.jsx';
import ScheduledArticleTableComponent from '../ScheduledArticleTable/ScheduledArticleTableComponent.jsx';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';


function MobileHomesComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, index } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const modelVM = _.get(submissionVM, pathUpdated)
    const { showConfirm } = useModal();

    const viewModelService = useContext(ViewModelServiceContext);

    modelVM.value.isValidationReq = true;

    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation,
        isComponentValid
    } = useValidation('MobileHomesComponent');


    const deleteMobileHomesDetails = useCallback(
        () => {
            const infoListPath = 'lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    const overrideProps = {
        propertyDetailsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.propertyDetails`,
            viewModelService
        },
        utilitiesComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.utilities`,
            viewModelService
        },
        oilTankComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.oilTank`,
            viewModelService,
            visible: _.get(submissionVM, `${pathUpdated}.value.utilities.auxHeaFueTypFie`) === 'Oil'
                || _.get(submissionVM, `${pathUpdated}.value.utilities.priHeaFueTypFie`) === 'Oil'
        },
        solidFuelHeatingComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.solidFuelHeating`,
            viewModelService,
            visible: (_.get(submissionVM, `${pathUpdated}.value.utilities.auxHeaFueTypFie`) === 'Wood'
                || _.get(submissionVM, `${pathUpdated}.value.utilities.priHeaFueTypFie`) === 'Wood')
        },
        additionalInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.additionalInformation`,
            viewModelService
        },
        hobbyFarmApplicationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.hobbyFarmApplication`,
            viewModelService,
            visible: _.get(submissionVM, `${pathUpdated}.value.additionalInformation.hobFarFie`) === true

        },
        incidentalOfficeComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.incidentalOfficeUse`,
            viewModelService,
            visible: _.get(submissionVM, `${pathUpdated}.value.additionalInformation.busonpreIncIncoffuuseFie`) === true
        },
        scheduledArticleTableComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            data: modelVM.scheduledArticles.scheduleArticleTable ? modelVM.scheduledArticles.scheduleArticleTable : [],
            updateWizardData,
            submissionVM,
            index,
            viewModelService,
            pathUpdated: `${pathUpdated}.scheduledArticles.scheduleArticleTable`,
        },
        mobileHomesAccordionDetails: {
            title: _.get(
                modelVM,
                `propertyDetails.accountLocFie.displayName.value`
            )
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deleteMobileHomesDetails
        },
        resolveComponentMap: {
            propertyDetailsComponent: PropertyDetailsComponent,
            utilitiesComponent: UtilitiesComponent,
            oilTankComponent: OilTankComponent,
            solidFuelHeatingComponent: SolidFuelHeatingComponent,
            additionalInformationComponent: AdditionalInformationComponent,
            hobbyFarmApplicationComponent: HobbyFarmApplicationComponent,
            incidentalOfficeComponent: IncidentalOfficeComponent,
            scheduledArticleTableComponent: ScheduledArticleTableComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, submissionVM, id, path, overrideProps),
        [metadata.componentContent, submissionVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            onModelChange={updateWizardData}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            resolveValue={readValue}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

MobileHomesComponent.propTypes = wizardProps;
export default withRouter(MobileHomesComponent);
